import { createBrowserRouter, Navigate } from 'react-router-dom';

import { AuthGuard } from '@/core/auth';
import { KeyImagesRefetchHandler } from '@/core/key-images-refetch-handler';
import { ErrorBoundaryRoute } from '@/modules/error-boundary';
import { NoAccessRoute } from '@/modules/no-access';
import { NotFoundRoute } from '@/modules/not-found';
import {
  FinalImpressionRoute,
  KeyImagesRoute,
  OrganRoute,
  PreviewRoute,
  ReasonForScanRoute,
  ReportingLayout,
} from '@/modules/reporting';
import { FormStructureGuard, StudyGuard } from '@/shared/guard';

export const ROUTES = createBrowserRouter(
  [
    {
      children: [
        {
          element: <Navigate replace to="reason-for-scan" />,
          index: true,
        },
        {
          element: <ReasonForScanRoute />,
          path: 'reason-for-scan',
        },
        {
          element: <OrganRoute />,
          path: 'organ/:organ',
        },
        {
          element: <KeyImagesRoute />,
          path: 'key-images',
        },
        {
          element: <FinalImpressionRoute />,
          path: 'final-impressions',
        },
        {
          element: <PreviewRoute />,
          path: 'preview',
        },
      ],
      element: (
        <AuthGuard>
          <StudyGuard>
            <FormStructureGuard>
              <KeyImagesRefetchHandler>
                <ReportingLayout />
              </KeyImagesRefetchHandler>
            </FormStructureGuard>
          </StudyGuard>
        </AuthGuard>
      ),
      errorElement: <ErrorBoundaryRoute />,
      path: '/reporting/:studyId',
    },
    {
      element: <Navigate replace to="/404" />,
      path: '*',
    },
    {
      element: (
        <AuthGuard>
          <NotFoundRoute />
        </AuthGuard>
      ),
      errorElement: <ErrorBoundaryRoute />,
      path: '404',
    },
    {
      element: <NoAccessRoute />,
      path: '401',
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);
